type TaskWithInstructions = {
  type: string;
  notes?: string | null;
  addressInstructions?: string | null;
  shipment?: { deliveryNotes?: string | null } | null;
};

/** Recorded Task guidance; never reconstruct it from the current Shipment. */
export function taskInstructions(task: TaskWithInstructions): string | null {
  if (task.type === "CUSTOMER_DELIVERY") {
    return task.notes?.trim() || null;
  }
  return task.addressInstructions?.trim() || null;
}

/** Whether a Task has recorded guidance or a separate handling note. */
export function taskHasVisibleNote(task: TaskWithInstructions): boolean {
  return Boolean(
    taskInstructions(task) ||
      (task.type !== "CUSTOMER_DELIVERY" && task.notes?.trim())
  );
}

export function taskInstructionLabel(task: TaskWithInstructions): string {
  return task.type === "CUSTOMER_DELIVERY" ? "Delivery instructions" : "Access";
}
